export default __webpack_public_path__ + "static/media/home-freelancer-text-bg.7e3c74fb.jpg";